import classNames from "classnames";

interface PropsType {
    label?: string,
    value?: boolean | undefined,
    onChange?: (value: boolean) => void,
    error?: string | undefined,
    disabled?: boolean,
}

export function InputCheckbox({ label, value, onChange = () => { }, error, disabled }: PropsType) {
    return (
        <div>
            <label className={
                classNames(
                    "input_checkbox_container text-sm font-medium text-gray-900 dark:text-gray-300",
                    {
                        "input_checkbox_container_enable": !disabled,
                        "input_checkbox_container_error": !disabled && error,
                        "input_checkbox_container_disable": disabled
                    }
                )
            }>
            {label}
                <input
                    checked={value}
                    type="checkbox"
                    onChange={(e) => onChange(e.target.checked)}
                    disabled={disabled}
                />

                    <span className="checkmark" />
            </label>
            {error && (
                <p className="mt-1.5 text-xs text-red-600 dark:text-red-500">{error}</p>
            )}
        </div>
    );
}